import { useEffect, useState } from "react";

import { useParams } from 'react-router-dom';
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import { Box, CircularProgress, Typography } from "@mui/material";
import { Check, PriorityHigh } from "@mui/icons-material";

import MDBox from "@vendor/components/MDBox";
import { BasicLayout } from "@shared/ui/auth/BasicLayout";
import bgImage from "@assets/images/sign_in_image_background.jpg";
import Coderland from "@assets/images/logos/logo.png";
import { setLayout, useMaterialUIController } from "@vendor/context";
import { useLoading } from "@shared/hooks/useLoading";
import MDButton from "@vendor/components/MDButton";
import {
    downloadInvoiceConfirmation,
    confirmInvoicePublic,
} from "../api/invoiceApi";
import { SendAutomaticInvoicePublic } from "../components/SendAutomaticInvoicePublic";
import { SendManualInvoicePublic } from "../components/SendManualInvoicePublic";

const ConfirmationInvoicePublicPage = () => {
    localStorage.setItem("token", "")
    const {loading, thisLoading, notLoading} = useLoading()
    const {id, token} = useParams();
    // El route param llega como `string | undefined`; las APIs y los diálogos hijos
    // (`SendAutomaticInvoicePublic`/`SendManualInvoicePublic`) ya están tipados con
    // `id: number`/`token: string` (slices anteriores). Se convierte acá una sola vez;
    // comportamiento preexistente si el link público no trae alguno de los dos params
    // (antes se les pasaba `undefined` tal cual a la request).
    const numericId = Number(id);
    const safeToken = token ?? "";
    const [error, setError] = useState(false)
    const [, dispatch] = useMaterialUIController();
    const [dialogAutomaticCharge, setDialogAutomaticCharge] = useState(false)
    const [dialogManualCharge, setDialogManualCharge] = useState(false)

    const onOpenDialogAutomaticCharge = () => setDialogAutomaticCharge(true)
    const onCloseDialogAutomaticCharge = () => setDialogAutomaticCharge(false)
    const onOpenDialogManualCharge = () => setDialogManualCharge(true)
    const onCloseDialogManualCharge = () => setDialogManualCharge(false)

    const onDownload = () => {
        thisLoading()
        downloadInvoiceConfirmation(safeToken, numericId)
            .then(({data, headers}) => {
                const link = document.createElement("a");
                link.target = "_blank";
                link.download = `factura${new Date().getTime()}.pdf`;
                link.href = window.URL.createObjectURL(
                    new Blob([data], {
                        type: headers["content-type"] as string | undefined,
                    })
                );
                link.click();
                notLoading()
            }).catch(() => notLoading())
    }

    const ShowIcons = () => {
        if (!loading && !error) {
            return (
                <>
                    <Box sx={{display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", mt: 5}}>
                        <Check color="success" fontSize='large'/>
                        <Typography>Tu factura fue cargada con exito</Typography>
                    </Box>
                    <Grid container spacing={3} sx={{mt: 5, p: 2}}>
                        <Grid
                            size={{
                                xs: 12,
                                md: 6
                            }}>
                            <MDButton variant="gradient" type="submit" color="info" fullWidth
                                      onClick={onDownload}>Descargar</MDButton>
                        </Grid>
                        <Grid
                            size={{
                                xs: 12,
                                md: 6
                            }}>
                            <MDButton variant="gradient" type="submit" color="info" fullWidth
                                      onClick={onOpenDialogManualCharge}>Carga Manual</MDButton>
                        </Grid>
                        <Grid size={12}>
                            <MDButton variant="gradient" type="submit" color="info" fullWidth
                                      onClick={onOpenDialogAutomaticCharge}>Carga
                                Automatica</MDButton>
                        </Grid>
                    </Grid>
                </>
            );
        }
        if (!loading && error) {
            return (
                <>
                    <PriorityHigh color="error" fontSize='large'/>
                    <Typography>Este link ya fue utilizado</Typography>
                </>
            )
        }

        if (loading) {
            return (
                <>
                    <CircularProgress/><Typography>Cargando...</Typography>
                </>
            )
        }
        return <></>
    }

    useEffect(() => {
        setLayout(dispatch, "pages")
    }, []);

    useEffect(() => {
        thisLoading()
        confirmInvoicePublic(safeToken, numericId).then(() => {
            notLoading()
        }).catch(() => {
            notLoading()
        })
    }, []);


    return (
        <BasicLayout image={bgImage}>
            <Card>
                <MDBox
                    bgColor="black"
                    borderRadius="lg"
                    coloredShadow="grey"
                    mx={2}
                    mt={-3}
                    p={2}
                    mb={1}
                    textAlign="center"
                >
                    <Grid container spacing={2} sx={{ justifyContent: "center", mt: 1, mb: 2 }}>
                        <img alt="Logo Coderland" src={Coderland} height="90%" width="90%"/>
                    </Grid>
                </MDBox>
                <Box sx={{display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", height: "300px"}}>
                    <ShowIcons/>
                </Box>
            </Card>
            <SendAutomaticInvoicePublic
                handleClose={onCloseDialogAutomaticCharge}
                open={dialogAutomaticCharge}
                notLoading={notLoading}
                loading={thisLoading}
                token={safeToken}
                id={numericId}
            />
            <SendManualInvoicePublic
                handleClose={onCloseDialogManualCharge}
                open={dialogManualCharge}
                notLoading={notLoading}
                loading={thisLoading}
                token={safeToken}
                id={numericId}
            />
        </BasicLayout>
    )
}

export { ConfirmationInvoicePublicPage };
